import { useReducer } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { initialState, detalleReducer } from './Shared/data/FormReducer';
import Home from './Pages/Home';
import Login from './Pages/Login';
import routes from './Config/routes';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import ChatWootLoader from './Components/Chatbot/ChatWootLoader';
import ProtectedRoute from './Components/ProtectedRoutes/ProtectedRoutes';

import './App.css';
import { useKeyboardFix } from './Components/UseKeyboardFix/UseKeyboardFix';


function App() {
  
  const [state, dispatch] = useReducer(detalleReducer, initialState);
  useKeyboardFix();

  return (
    <div className="App h-full relative">
      <BrowserRouter>

        <ChatWootLoader />

        <Header
          state={state}
          dispatch={dispatch}
          routes={
            <Routes>
              {routes.map((route, index) => (
                <Route
                  key={index}
                  path={route.path}
                  element={
                    route.name === 'Login' ? (
                      <Login state={state} dispatch={dispatch} />
                    ) : (
                      <ProtectedRoute>
                        {route.name === 'Home' ? (
                          <Home state={state} dispatch={dispatch} />
                        ) : (
                          <route.component name={route.name} {...route.props} />
                        )}
                      </ProtectedRoute>
                    )
                  }
                />
              ))}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          }
        />
      <Footer />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
